export default __webpack_public_path__ + "static/media/e_commerce.28c83816.svg";